module.exports = __webpack_public_path__ + "img/Eggs.bd998975.svg";